<template>
  <button
    class="text-c-2 hover:text-c-1 underline"
    type="button">
    <slot />
  </button>
</template>
